import Moment from 'react-moment';
import { Typography, Box, useTheme } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import React, { useState, useEffect  } from "react";
import { clearMessage, setMessage } from "../../slices/message";
import { getUser , updateUser} from "../../slices/user";


const NiceUser = (props) => {

  const dispatch = useDispatch();
  //debugger;
  const user = useSelector((state) => state.user.users.data.list?.find(user => user.username === props.children));

  useEffect(() => {
    if(!user){
      //need to get the user to display 
      let username = props.children;

      dispatch(getUser({username}));
    };

}, [user]);

return (
  <>
  {user &&
  <Box display="flex" justifyContent="start" alignItems="baseline"> 
    <Typography display="inline" >{`${user.firstName} ${user.lastName}`}</Typography> 
    <Typography variant="title" color="inherit" noWrap>
      &nbsp;
    </Typography>
    <Typography variant="small" display="inline">{`(${user.username})`}</Typography>
  </Box>
}
</>)
}

export default NiceUser;